// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import VideoCameraOutlined from '/Users/zsnmwy/code/bilibili-report-manager/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/@ant-design/icons/es/icons/VideoCameraOutlined';
export default { VideoCameraOutlined };
